import React from 'react'
import cx from 'classnames'

const Divider = ({ className }) => {
  return <hr className={cx('my-2', className)}></hr>
}

export default Divider
